export default class LoginButtonHelper {

    constructor() {
        if(this.loginbutton = document.querySelector("#login")) {
            this._disableLoginButtonOnSubmit()
        }
    }

    _disableLoginButtonOnSubmit() {
    var form = document.querySelector('.form--login');

    form.addEventListener("submit", function () {
        document.querySelector('#login').disabled = true;
    });
    }
}